import { ContractInformation } from './components/ContractInformation'
import { Premiums } from './components/Premiums'
import { Remark } from './components/Remark'
import { Schedule } from './components/Schedule'
import type { Contract } from './typings/Contract'

export interface ViewContractScreenContentProps {
  contract: Contract
  showContractType?: boolean
  showCommittee?: boolean
  showCostPlace?: boolean
  showDimonaAttestation?: boolean
  onReSendWorkObstruction?: (workObstructionId: string) => any
}

export const ViewContractScreenContent = ({
  contract,
  showContractType = false,
  showCommittee = false,
  showCostPlace = false,
  showDimonaAttestation = false,
  onReSendWorkObstruction
}: ViewContractScreenContentProps) => {
  return (
    <>
      <ContractInformation
        contract={contract}
        showContractType={showContractType}
        showCommittee={showCommittee}
        showCostPlace={showCostPlace}
        showDimonaAttestation={showDimonaAttestation}
      />
      <Schedule
        contract={contract}
        onReSendWorkObstruction={onReSendWorkObstruction}
      />
      <Premiums contract={contract} />
      <Remark contract={contract} />
    </>
  )
}
